export type TextAs = 'div' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'label' | 'blockquote';

export type SharedTextProps = {
  variant: TextVariant;
  as?: TextAs;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  id?: string;
};

type TextCharacteristics = {
  element: TextAs;
  className: string;
};
type Variants = {
  [K in TextVariant]: TextCharacteristics;
};

export enum TextVariant {
  TitleDisplayXL = 'title-display-xl',
  TitleDisplayLG = 'title-display-lg',
  TitleDisplayMD = 'title-display-md',
  TitleLG = 'title-lg',
  TitleMD = 'title-md',
  TitleSM = 'title-sm',
  TitleXS = 'title-xs',
  SubtitleLG = 'subtitle-lg',
  SubtitleMD = 'subtitle-md',
  SubtitleSM = 'subtitle-sm',
  TextBodyLG = 'text-body-lg',
  TextBodyMD = 'text-body-md',
  TextBodySM = 'text-body-sm',
  TextBlockquoteLG = 'text-blockquote-lg',
  TextBlockquoteMD = 'text-blockquote-md',
  TextBlockquoteSM = 'text-blockquote-sm',
  TextLabel = 'text-label',
  TextUnicase = 'text-unicase',
  TextDescription = 'text-description',
  TemplateTextSM = 'template-text-sm',
  TextStats = 'text-stats',
  TextJakartaLG = 'text-jakarta-lg',
  TextJakartaMD = 'text-jakarta-md',
  TextJakartaSM = 'text-jakarta-sm',
  TitleHighlights = 'title-highlights',
}

export const VARIANTS: Variants = {
  [TextVariant.TitleDisplayXL]: {
    element: 'h1',
    className: 'text-6xl lg:text-7xl xl:text-8xl scroll-m-20',
  },
  [TextVariant.TitleDisplayLG]: {
    element: 'h1',
    className: 'text-4xl md:text-5xl lg:text-6xl xl:text-7xl scroll-m-20',
  },
  [TextVariant.TitleDisplayMD]: {
    element: 'h1',
    className: 'text-4xl md:text-5xl lg:text-6xl scroll-m-20',
  },
  [TextVariant.TitleLG]: {
    element: 'h2',
    className: 'text-3xl md:text-4xl lg:text-5xl',
  },
  [TextVariant.TitleMD]: {
    element: 'h2',
    className: 'text-2xl lg:text-3xl',
  },
  [TextVariant.TitleSM]: {
    element: 'h2',
    className: 'text-3xl ',
  },
  [TextVariant.TitleXS]: {
    element: 'h2',
    className: 'text-lg',
  },
  [TextVariant.SubtitleLG]: {
    element: 'p',
    className: 'text-base-semibold',
  },
  [TextVariant.SubtitleMD]: {
    element: 'p',
    className: 'text-xs-medium md:text-sm-medium',
  },
  [TextVariant.SubtitleSM]: {
    element: 'p',
    className: 'text-xs-semibold',
  },
  [TextVariant.TextBodyLG]: {
    element: 'p',
    className: 'text-sm-regular md:text-base-regular text-body-foreground font-regular',
  },
  [TextVariant.TextBodyMD]: {
    element: 'p',
    className: 'text-sm-regular text-body-foreground font-regular',
  },
  [TextVariant.TextBodySM]: {
    element: 'p',
    className: 'text-xs-regular text-body-foreground font-regular',
  },
  [TextVariant.TextBlockquoteLG]: {
    element: 'blockquote',
    className: 'text-2xl lg:text-3xl',
  },
  [TextVariant.TextBlockquoteMD]: {
    element: 'blockquote',
    className: 'text-lg sm:text-2xl',
  },
  [TextVariant.TextBlockquoteSM]: {
    element: 'blockquote',
    className: 'text-base-regular font-regular',
  },
  [TextVariant.TextLabel]: {
    element: 'label',
    className: 'text-xs-regular font-regular',
  },
  [TextVariant.TextUnicase]: {
    element: 'p',
    className: 'text-unicase-sm text-accent-foreground uppercase font-regular',
  },
  [TextVariant.TextDescription]: {
    element: 'p',
    className: 'text-description-sm md:text-description-lg text-body-foreground font-regular',
  },
  [TextVariant.TemplateTextSM]: {
    element: 'p',
    className: 'text-xs-medium lg:text-sm-medium',
  },
  [TextVariant.TextStats]: {
    element: 'p',
    className: 'text-3xl lg:text-6xl',
  },
  [TextVariant.TextJakartaLG]: {
    element: 'p',
    className: 'text-3xl',
  },
  [TextVariant.TextJakartaMD]: {
    element: 'p',
    className: 'text-2xl',
  },
  [TextVariant.TextJakartaSM]: {
    element: 'p',
    className: 'text-lg lg:text-xl',
  },
  [TextVariant.TitleHighlights]: {
    element: 'p',
    className: 'text-lg lg:text-xl',
  },
};
